import useQueryParam from './useCustomQueryParam';

const PRIMARY_THEME_COLOR = 'primary_p3_main';

export default function useIsPrimaryTheme() {
  const [themeQP] = useQueryParam<string>('theme');

  return themeQP === PRIMARY_THEME_COLOR;
}
